import { FetchAPI } from 'utils/fetch/fetch-api';
import { LeadsListDTO } from 'utils/types/leads';
import { RequestQuery } from 'utils/types/request-types';

class LeadsService extends FetchAPI {
	leadsList = (query: RequestQuery): Promise<LeadsListDTO> => this.get<LeadsListDTO>(query);
}
export { LeadsService };
